export const CURRENT_YEAR = new Date().getFullYear();

export function getSeasonStart() {
    return new Date(CURRENT_YEAR, 6, 1);
}

export function getSeasonEnd() {
    return new Date(CURRENT_YEAR, 7, 31);
}
